<template>
    <v-dialog v-model="open"
        max-width="800px"
        persistent
        :fullscreen="$vuetify.breakpoint.xsOnly">
        <v-card :loading="loading" class="background-2 round-card">
            <v-card-title class="pa-3">
                <p class="pl-2 pl-xl-3">Gestisci Mail List</p>
                <v-spacer></v-spacer>
            </v-card-title>
            <v-divider></v-divider>
            <v-card-text class="pa-0">
                <v-container class="pa-2" fluid>
                <v-radio-group class="pl-4" v-model="model.action">
                    <template slot="label">
                        <div class="subheading font-weight-light pb-4">Anagrafiche selezionate <span class="font-weight-medium">{{ allSelected ? allCount : selected.length }}</span>
                        </div>
                    </template>						
                    <v-radio value="remove" color="red">
                        <template slot="label">
                            <div><strong class="red--text">Rimuovi</strong> dalla lista selezionata</div>
                        </template>
                    </v-radio>
                    <v-radio value="add" color="info">
                        <template slot="label">
                            <div><strong class="info--text">Aggiungi</strong> alla lista selezionata</div>
                        </template>
                    </v-radio>
                </v-radio-group>
                <fields-generator
                        v-if="loaded"
                        :fieldsset.sync="dialogFieldsset"
                        :model.sync="model"
                        ref="fieldsgenerator"
                    ></fields-generator>

                <small class="pl-4">* Indica i campi obbligatori</small>
                </v-container>
            </v-card-text>
            <v-divider></v-divider>
            <v-card-actions class="px-2">
                <v-spacer></v-spacer>
                <v-btn color="primary" text @click.native.stop="closeMailListDialog()">Chiudi</v-btn>
                <v-btn color="info" :disabled="loading" text :loading="saved" @click.native="saveMailList()">Salva</v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>

	export default {
		name: 'maillist-dialog',
		props: {
            params: {
                default: () => {},
                required: false
            },
            selected: Array,
            selectedIds: Array,
            modelDef: String,
            open: Boolean,
            // selezione "tutti" di Crud: il backend risolve l'insieme con select_all sui filtri della tabella
            allSelected: Boolean,
            allCount: Number,
            listFilters: Object,
		},
		data() {
            return {
                loading: true,
                loaded: false,
                model: { action : 'add' },
                saved: false,
                dialogFieldsset: {}
			}
        },

        watch: {
            open(val) {
                if (val) {
                    this.axios.get('maillists-dialog-info/').then(response => {
                        this.dialogFieldsset = response.data.fields
                        this.loaded = true
                        this.loading = false
                    }, response => {
                        // error callback
                    })            
                }
            }
        },
        

        methods: {
            saveMailList() {
                this.$refs.fieldsgenerator.$validator.validateAll().then(result => {
					if (!result) {
						return false
                    }
                    this.saved = true
                    let url = (this.params && this.params.url) ? this.params.url : 'companiesmaillists'
					this.axios.post(url+'/', {selected: this.selectedIds, model: this.model, select_all: this.allSelected, ...(this.allSelected ? this.listFilters : {}), class: this.modelDef}).then(response => {

                        this.saved = false
						this.closeMailListDialog()
                        
                        this.$store.commit('setSnackbar', {timeout: 6000, text: response.data.message, value: true, color: response.data.status})

					}, response => {
                        // error callback
                        this.saved = false
					})

				}).catch(() => {

				})
			},

			closeMailListDialog() {
                this.model = { action : 'add' }
                this.$emit('close')
			}
        },
	}
</script>

